import helpers from '@/plugins/helpers'
import Axios from 'axios'


export default {

  find(url, fields, filters, options) {
    filters = !helpers.nullOrEmpty(filters) ? filters : null
    options = !helpers.nullOrEmpty(options) ? options : null
    if (options != null && options.sortBy != null && options.sortDesc != null) {
      options.order = {
        field: options.sortBy[0],
        direction: options.sortDesc[0] ? 'DESC' : 'ASC'
      }

    }


    return Axios.get(
      process.env.VUE_APP_ENDPOINT + url,
      {
        params: {
          fields: fields,
          filters: formatFilters(filters),
          options: options
        }
      }
    ).then((response) => {
      if (!response.data.extra) {
        helpers.setAlertMessage(1, 'No hay resultados disponibles')
        return {}
      }
      if (response.data.extra.results === false) {
        helpers.setAlertMessage(1, 'Al menos un campo no disponible en la vista')
      }
      response.data.extra.filters = packOrFilters(filters)
      return response.data.extra
    })

  }
}

function unpackOrFilter(filters) {
  if (filters == null) {
    return null
  }
  let result = []
  Object.keys(filters).forEach(fsKey => {
    result.push(
      {
        field: fsKey.replace('[~]', ''),
        operator: 'LIKE',
        condition: 'OR',
        value: filters[fsKey]
      }
    )
  })
  return result
}

function packOrFilters(filters) {
  if (filters == null) {
    return null
  }
  let result = {}
  Object.keys(filters).forEach(field => {

    if (field.includes('[~]')) {
      field = field.replace('[~]', '')
    }
    result[field] = filters[field]
  })
  return result
}

function formatFilters(filters) {
  //filters foreach key value
  /*
  const EQUAL = "EQUAL";
  const NOTEQUAL = "NOTEQUAL";
  const RANGE = "RANGE";
  const IN = "IN";
  const NOTIN = "NOTIN";
  const GTE = "GTE";
  const LTE = "LTE";
  const FULLSEARCH = "FULLSEARCH";
  const LIKE = "LIKE";
   */
  if (filters == null) {
    return null
  }
  let result = []
  Object.keys(filters).forEach(key => {
    let operator = 'EQUAL'
    if (typeof filters[key] == 'object') {
      operator = key.indexOf('timestamp') == -1 ? 'IN' : 'RANGE'
    }

    if (key == 'OR') {
      result = result.concat(unpackOrFilter(filters[key]))
    } else if (key.includes('timestamp')) {
      if (filters[key] != null) {
        result.push(
          {
            field: key,
            operator: 'RANGE',
            value: filters[key].type !== 'custom' ? helpers.getTimestampValues(filters[key].type) : {
              from: filters[key].from,
              to: filters[key].to
            }
          }
        )

      }

    } else if (key == 'timeBetween') {
      if (filters[key] != null) {
        result.push(
          {
            field: 'time',
            operator: 'RANGE',
            value: {
              from: parseInt(filters[key][0]),
              to: parseInt(filters[key][1])
            }
          }
        )

      }

    } else if (key == 'FULLSEARCH') {
      result.push(
        {
          field: key,
          operator: 'FULLSEARCH',
          value: filters[key]
        }
      )
      delete filters['FULLSEARCH']

    } else {
      if (filters['OR'] != null) {
        delete filters['OR'][key + '[~]']
      }
      result.push(
        {
          field: key,
          operator: operator,
          value: filters[key]
        }
      )

    }

  })
  return JSON.stringify(result)
}
